import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addCallsBlackList,
  deleteCallsBlackList,
  fetchCallsBlackList,
  updateCallsBlackList,
} from "../../apis/callsBlacklist";

export const fetchCallsBlacklistList = createAsyncThunk(
  "callsBlacklist/fetchCallsBlacklist",
  async (_, { rejectWithValue }) => {
    try {
      const person = await fetchCallsBlackList();
      return person;
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  },    {
    condition: (_, { getState }) => {
      const state = getState() as any; // Replace 'any' with your RootState type
      return !state.callBlackList.isDataFetched; // Adjust path based on your state structure
    }
  }
);

export const updateCallsBlacklist = createAsyncThunk(
  "callsBlacklist/updateCallsBlacklist",
  async (
    {
      blacklist_id,
      data,
    }: {
      blacklist_id: string;
      data: {
        [key: string]: any;
        blacklist_id: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      await updateCallsBlackList(blacklist_id, data);
      return { success: true, data };
      // return person;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteCallsBlacklist = createAsyncThunk(
  "callsBlacklist/deleteCallsBlacklist",
  async (
    {
      blacklist_id,
    }: {
      blacklist_id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteCallsBlackList(blacklist_id);
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  }
);

export const addNewCallsBlacklistsData = createAsyncThunk(
  "callsBlacklist/addCallsBlacklist",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addCallsBlackList(data);
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  }
);
